import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';
import type {UserInfo, UserRequest} from "$lib/types/user";

export const count = writable(0);
export const JwtStore: Writable<string | null> = writable(null);
export const UserStore: Writable<UserInfo | null> = writable(null);
export const authModal: Writable<boolean> = writable(false);
export const restoreModal: Writable<boolean> = writable(false);
export const moderationModal: Writable<boolean> = writable(true);
export const editProfileModal: Writable<boolean> = writable(false);
export const registeringUser: Writable<UserRequest | null> = writable(null);
export const deviceWidth = writable(0);
export const feedbackModal: Writable<boolean> = writable(false);
export const languageModal: Writable<string | null> = writable(null);
